const categoryTileStates = () => {
    const categoryTiles = document.querySelectorAll('.Category-tile');

    if (categoryTiles) {
        categoryTiles.forEach((el) => {
            const name = el.querySelector('.Category-tile__name-wr');
            const image = el.querySelector('.Category-tile__image-wr');

            name.addEventListener('mouseover', () => {
                el.classList.add('--Is-hovered');
            });
            name.addEventListener('mouseout', () => {
                el.classList.remove('--Is-hovered');
            });

            image.addEventListener('mouseover', () => {
                el.classList.add('--Is-hovered');
            });
            image.addEventListener('mouseout', () => {
                el.classList.remove('--Is-hovered');
            });
        });
    }
};

export default categoryTileStates;
